/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Article = ContentItem & {
  __typename?: 'Article';
  author: ContentAuthor;
  body: Scalars['String'];
  /**
   * The SEO description without needing to go through the 'seo' object
   *
   * Note: This defaults to grab the first 3 sentences from the 'body' if the SEO description isn't present in the CMS
   */
  description: Scalars['String'];
  firstPublishedAt?: Maybe<Scalars['String']>;
  hero?: Maybe<ArticleHero>;
  id: Scalars['ID'];
  lastPublishedAt?: Maybe<Scalars['String']>;
  modifiedDate: Scalars['String'];
  publishedDate?: Maybe<Scalars['String']>;
  seo: SeoInformation;
  slug: Scalars['String'];
  sport: Sport;
  tags?: Maybe<Array<Maybe<ContentTag>>>;
  thumbnailImageUrl?: Maybe<ImageReference>;
  title: Scalars['String'];
};

/** Data encapsulating a specific article and the id to help with pagination */
export type ArticleConnection = {
  __typename?: 'ArticleConnection';
  cursor: Scalars['String'];
  entity: Article;
};

export type ArticleHero = {
  __typename?: 'ArticleHero';
  imageUrl?: Maybe<ImageReference>;
  jwPlayerId?: Maybe<Scalars['String']>;
  jwPlayerPlayerId?: Maybe<Scalars['String']>;
  /** Defaults to IMAGE if no JWPLAYER media is present */
  type: HeroType;
};

/** List of articles including pagination data and total articles in the list */
export type ArticleList = {
  __typename?: 'ArticleList';
  articles: Array<Maybe<ArticleConnection>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Filter article searches */
export type ArticleSearchInput = {
  /**
   * Case-sensitive
   *
   * Used for pagination. Retrieve items that come after the given id.
   */
  afterCursor?: InputMaybe<Scalars['String']>;
  /**
   * Case-sensitive
   *
   * Filter article searches by those that were written by a specific author with the given id.
   */
  author?: InputMaybe<AuthorInput>;
  /**
   * Case-sensitive
   *
   * Filter article searches by those that contain a specific HeroType
   */
  heroType?: InputMaybe<HeroType>;
  /**
   * Default 10.
   *
   * Input how many items to return.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Format: ISO, i.e. YYYY-MM-DDTHH:mm:ssZ
   *
   * Filter article searches by those published within a given timeline
   */
  publishedWithin?: InputMaybe<TimestampBoundaries>;
  /**
   * Case-sensitive
   *
   * Filter article searches by those about the given sport.
   */
  sportName?: InputMaybe<Scalars['String']>;
  /**
   * Case-sensitive
   *
   * Filter article searches by those with the given title.
   */
  title?: InputMaybe<Scalars['String']>;
};

export type AuthorInput = {
  /** The author's id */
  id?: InputMaybe<Scalars['String']>;
};

/** Filter author searches */
export type AuthorSearchInput = {
  /** Used for pagination. Retrieve items that come after the given id. */
  afterCursor?: InputMaybe<Scalars['String']>;
  /**
   * Default 10.
   *
   * Input how many items to return.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Case-sensitive
   *
   * Filter author searches by those who have written about the given sport.
   */
  sportName?: InputMaybe<Scalars['String']>;
};

export type ContentAuthor = {
  __typename?: 'ContentAuthor';
  authoredContent?: Maybe<Array<Maybe<ContentItem>>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  socialMedia?: Maybe<Array<Maybe<SocialMediaAccount>>>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};


export type ContentAuthorAuthoredContentArgs = {
  contentType?: InputMaybe<Type>;
};

/** Data encapsulating a specific author and the id to help with pagination */
export type ContentAuthorConnection = {
  __typename?: 'ContentAuthorConnection';
  cursor: Scalars['String'];
  entity: ContentAuthor;
};

/** List of authors including pagination data and total authors in the list */
export type ContentAuthorList = {
  __typename?: 'ContentAuthorList';
  authors: Array<Maybe<ContentAuthorConnection>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ContentFeed = {
  __typename?: 'ContentFeed';
  contentItems: Array<Maybe<ContentItem>>;
  context: Scalars['String'];
  sport: Sport;
  totalCount: Scalars['Int'];
};

/** WIP */
export type ContentFeedInput = {
  afterCursor?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<AuthorInput>;
  context?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  relatedEntity?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<Scalars['String']>;
};

export type ContentItem = {
  author: ContentAuthor;
  id: Scalars['ID'];
  modifiedDate: Scalars['String'];
  publishedDate?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Maybe<ContentTag>>>;
  title: Scalars['String'];
};

export type ContentSummary = ContentItem & {
  __typename?: 'ContentSummary';
  author: ContentAuthor;
  cursor: Scalars['String'];
  id: Scalars['ID'];
  modifiedDate: Scalars['String'];
  publishedDate?: Maybe<Scalars['String']>;
  seoDescription: Scalars['String'];
  slug: Scalars['String'];
  tags?: Maybe<Array<Maybe<ContentTag>>>;
  thumbnailUrl: Scalars['String'];
  title: Scalars['String'];
  type: Type;
};

export type ContentTag = {
  __typename?: 'ContentTag';
  id: Scalars['String'];
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<ImageReference>;
  type?: Maybe<Scalars['String']>;
};

/** Filter featured article searches */
export type FeaturedArticleInput = {
  /**
   * Case-sensitive
   *
   * Filter featured article searches by those on a specific page.
   */
  pageType?: InputMaybe<PageType>;
  /**
   * Case-sensitive
   *
   * Filter featured article searches by those about the given sport.
   */
  sportName?: InputMaybe<Scalars['String']>;
};

export type Fixture = {
  __typename?: 'Fixture';
  currentGameTime?: Maybe<Scalars['String']>;
  gameStatus?: Maybe<GameStatus>;
  /** Summarises a single fixture. */
  id: Scalars['ID'];
  scheduledEndTime?: Maybe<Scalars['String']>;
  scheduledStartTime?: Maybe<Scalars['String']>;
  sport?: Maybe<Sport>;
  teams: Array<Maybe<FixtureTeamSummary>>;
  /** Implement post MVP */
  tvNetwork?: Maybe<TvNetwork>;
};

/** Filter active fixture searches */
export type FixtureSearchInput = {
  /**
   * Case-insensitive
   *
   * Filter active fixture searches by a specific sport.
   */
  sport?: InputMaybe<Scalars['String']>;
};

export type FixtureTeamSummary = {
  __typename?: 'FixtureTeamSummary';
  currentScore?: Maybe<Scalars['Int']>;
  moneyLine?: Maybe<Scalars['Int']>;
  pointSpread?: Maybe<Scalars['Float']>;
  team: Team;
};

export enum GameStatus {
  Final = 'FINAL',
  InProgress = 'IN_PROGRESS',
  Scheduled = 'SCHEDULED'
}

/** Container type describing an individual sport. */
export type GenericSport = Sport & SportsEntity & {
  __typename?: 'GenericSport';
  description?: Maybe<Scalars['String']>;
  governingBody?: Maybe<Scalars['String']>;
  hasLiveScoring?: Maybe<Scalars['Boolean']>;
  hasPlayerUpdates?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  logo?: Maybe<ImageReference>;
  name: Scalars['String'];
  relatedContent?: Maybe<Array<Maybe<ContentItem>>>;
  seo: SeoInformation;
  slug: Scalars['String'];
};

/** The media type found on an article */
export enum HeroType {
  Image = 'IMAGE',
  Jwplayer = 'JWPLAYER'
}

export type ImageReference = {
  __typename?: 'ImageReference';
  url: Scalars['String'];
};

export enum LinkBehaviour {
  NewWindow = 'NEW_WINDOW',
  Standard = 'STANDARD'
}

/** Top-level entity describing a single menu */
export type Menu = {
  __typename?: 'Menu';
  iconUrl?: Maybe<Scalars['String']>;
  menuItems: Array<Maybe<NestedLink>>;
  name: Scalars['String'];
};

export type MenuSearchInput = {
  name?: InputMaybe<Scalars['String']>;
};

/**
 * Individual link w/caption.
 * The "children" field is a allows for nested menus - an array
 * of NestedLink can represent the top-level menu.
 */
export type NestedLink = {
  __typename?: 'NestedLink';
  behaviour?: Maybe<LinkBehaviour>;
  children?: Maybe<Array<Maybe<NestedLink>>>;
  iconUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  url: Scalars['String'];
};

export type OpenGraphTag = {
  __typename?: 'OpenGraphTag';
  image?: Maybe<ImageReference>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  cursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
};

/** The page where to find featured articles */
export enum PageType {
  Homepage = 'HOMEPAGE',
  Sport = 'SPORT'
}

export type Player = SportParticipant & SportsEntity & {
  __typename?: 'Player';
  identifier: Scalars['String'];
  image?: Maybe<ImageReference>;
  name: Scalars['String'];
  relatedContent?: Maybe<Array<Maybe<ContentItem>>>;
  sports?: Maybe<Array<Maybe<Sport>>>;
  type: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /**
   * Returns the "current" set of fixtures.
   * What constitutes "current" is determined by the server.
   */
  getActiveFixtures?: Maybe<Array<Maybe<Fixture>>>;
  /** Retrieve all articles */
  getArticles?: Maybe<ArticleList>;
  /**
   * Returns all authors
   * Combine with the article/short-form retrieval queries to obtain all
   * content written by one or more specific authors
   */
  getAuthors?: Maybe<ContentAuthorList>;
  /**
   * Returns content feed for a given context
   * (e.g. home page) & sport.
   *
   * TODO: define behaviour if neither context nor sport
   * are provided.
   *
   * WIP
   */
  getContentFeed?: Maybe<ContentFeed>;
  /**
   * Returns the featured articles from the given page type.
   *
   * Note: If wanting the `SPORT` featured articles, be sure to specify the `sportName`
   */
  getFeaturedArticles?: Maybe<Array<Maybe<Article>>>;
  /** Returns a specific fixture, including the score summaries. */
  getFixture?: Maybe<Fixture>;
  /** Search for one or more menus. */
  getMenu?: Maybe<Array<Maybe<Menu>>>;
  /** Retrieve _all_ menu. */
  getMenus?: Maybe<Array<Maybe<Menu>>>;
  /**
   * Obtain latest scores for a given fixture.
   * The expectation is that the front-end will hit this query fairly frequently in order to supply quasi-realtime score information.
   *
   * In the absence of an `input` value, this query will return scores for all fixtures - that is, the equivalent
   * of running `getActiveFixtures`, and then `getScoreUpdates` for all fixtures.
   *
   * Note: this query is likely to be superseded in the future by a streaming solution.
   * WIP
   */
  getScoreUpdates?: Maybe<Array<Maybe<ScoreUpdate>>>;
  /** Retrieve a specific piece of short-form content */
  getShortForm?: Maybe<ShortForm>;
  /** Retrieve all items of short-form contenet */
  getShortForms?: Maybe<ShortFormList>;
  /** Retrieve a specific article */
  getSingleArticle?: Maybe<Article>;
  /** Returns a list of all supported sports */
  getSupportedSports?: Maybe<Array<Maybe<Sport>>>;
};


export type QueryGetActiveFixturesArgs = {
  input?: InputMaybe<FixtureSearchInput>;
};


export type QueryGetArticlesArgs = {
  filter: ArticleSearchInput;
};


export type QueryGetAuthorsArgs = {
  input?: InputMaybe<AuthorSearchInput>;
};


export type QueryGetContentFeedArgs = {
  filter?: InputMaybe<ContentFeedInput>;
};


export type QueryGetFeaturedArticlesArgs = {
  filter?: InputMaybe<FeaturedArticleInput>;
};


export type QueryGetFixtureArgs = {
  id: Scalars['ID'];
};


export type QueryGetMenuArgs = {
  input?: InputMaybe<MenuSearchInput>;
};


export type QueryGetMenusArgs = {
  isPreview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetScoreUpdatesArgs = {
  input?: InputMaybe<ScoreUpdateInput>;
};


export type QueryGetShortFormArgs = {
  contentStatus?: InputMaybe<StatusSelector>;
  slug: Scalars['String'];
};


export type QueryGetShortFormsArgs = {
  filter: ShortFormSearchInput;
};


export type QueryGetSingleArticleArgs = {
  contentStatus?: InputMaybe<StatusSelector>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};


export type QueryGetSupportedSportsArgs = {
  isPreview?: InputMaybe<Scalars['Boolean']>;
};

export type SeoInformation = {
  __typename?: 'SEOInformation';
  canonicalUrl?: Maybe<Scalars['String']>;
  /** Note: This defaults to grab the first 3 sentences from the 'body' of the content item if the SEO description isn't present in the CMS */
  description?: Maybe<Scalars['String']>;
  image?: Maybe<ImageReference>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  noIndex?: Maybe<Scalars['Boolean']>;
  openGraphTag?: Maybe<OpenGraphTag>;
  synonyms?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
};

export type ScoreEventMapping = {
  __typename?: 'ScoreEventMapping';
  /**
   * Represents a single score in a game (i.e. the event of the score itself).
   * This is *NOT* a summary of scores for a given team or player within a fixture.
   */
  fixture: Fixture;
  score: Scalars['Int'];
  scoreTime?: Maybe<Scalars['String']>;
  scoringPlayer: Player;
  scoringTeam: Team;
};

export type ScoreUpdate = {
  __typename?: 'ScoreUpdate';
  entityUpdates: Array<Maybe<ScoreEventMapping>>;
};

export type ScoreUpdateInput = {
  fixtureId: Scalars['String'];
};

export type ShortForm = ContentItem & {
  __typename?: 'ShortForm';
  author: ContentAuthor;
  body: Scalars['String'];
  /**
   * The SEO description without needing to go through the 'seo' object
   *
   * Note: This defaults to grab the first 3 sentences from the 'body' if the SEO description isn't present in the CMS
   */
  description: Scalars['String'];
  firstPublishedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastPublishedAt?: Maybe<Scalars['String']>;
  modifiedDate: Scalars['String'];
  publishedDate?: Maybe<Scalars['String']>;
  seo: SeoInformation;
  slug: Scalars['String'];
  tags: Array<Maybe<ContentTag>>;
  title: Scalars['String'];
};

/** Data encapsulating a specific short form and the id to help with pagination */
export type ShortFormConnection = {
  __typename?: 'ShortFormConnection';
  cursor: Scalars['String'];
  entity: ShortForm;
};

/** List of short forms including pagination data and total short forms in the list */
export type ShortFormList = {
  __typename?: 'ShortFormList';
  pageInfo: PageInfo;
  shortForms: Array<Maybe<ShortFormConnection>>;
  totalCount: Scalars['Int'];
};

/** Filter short form searches */
export type ShortFormSearchInput = {
  /**
   * Case-sensitive
   *
   * Used for pagination. Retrieve items that come after the given id.
   */
  afterCursor?: InputMaybe<Scalars['String']>;
  /**
   * Case-sensitive
   *
   * Filter short form searches by those that were written by a specific author with the given id.
   */
  author?: InputMaybe<AuthorInput>;
  /**
   * Default 10.
   *
   * Input how many items to return.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Format: ISO, i.e. YYYY-MM-DDTHH:mm:ssZ
   *
   * Filter short form searches by those published within a given timeline
   */
  publishedWithin?: InputMaybe<TimestampBoundaries>;
  /**
   * Case-sensitive
   *
   * Filter short form searches by those about the given sport.
   */
  sportName?: InputMaybe<Scalars['String']>;
  /**
   * Case-sensitive
   *
   * Filter short form searches by those about the given team.
   */
  teamId?: InputMaybe<Scalars['String']>;
  /**
   * Case-sensitive
   *
   * Filter short form searches by those with the given title.
   */
  title?: InputMaybe<Scalars['String']>;
};

/** An author's social media data */
export type SocialMediaAccount = {
  __typename?: 'SocialMediaAccount';
  accountName: Scalars['String'];
  type: SocialMediaType;
  url: Scalars['String'];
};

/** Available social medias authors may have */
export enum SocialMediaType {
  Instagram = 'INSTAGRAM',
  Twitter = 'TWITTER'
}

export type Sport = {
  description?: Maybe<Scalars['String']>;
  governingBody?: Maybe<Scalars['String']>;
  hasLiveScoring?: Maybe<Scalars['Boolean']>;
  hasPlayerUpdates?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  logo?: Maybe<ImageReference>;
  name: Scalars['String'];
  relatedContent?: Maybe<Array<Maybe<ContentItem>>>;
  seo: SeoInformation;
  slug: Scalars['String'];
};

export type SportParticipant = {
  identifier: Scalars['String'];
  image?: Maybe<ImageReference>;
  name: Scalars['String'];
  relatedContent?: Maybe<Array<Maybe<ContentItem>>>;
  sports?: Maybe<Array<Maybe<Sport>>>;
  type: Scalars['String'];
};

export type SportsEntity = {
  relatedContent?: Maybe<Array<Maybe<ContentItem>>>;
};

/** The published status of a Content Item */
export enum StatusSelector {
  Both = 'BOTH',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type TvNetwork = {
  __typename?: 'TVNetwork';
  name: Scalars['String'];
};

export type Team = SportParticipant & SportsEntity & {
  __typename?: 'Team';
  abbreviation?: Maybe<Scalars['String']>;
  drawCount: Scalars['Int'];
  identifier: Scalars['String'];
  image?: Maybe<ImageReference>;
  loseCount: Scalars['Int'];
  name: Scalars['String'];
  primaryColor?: Maybe<Scalars['String']>;
  relatedContent?: Maybe<Array<Maybe<ContentItem>>>;
  secondaryColor?: Maybe<Scalars['String']>;
  sports?: Maybe<Array<Maybe<Sport>>>;
  type: Scalars['String'];
  winCount: Scalars['Int'];
};

/** Format: ISO, i.e. YYYY-MM-DDTHH:mm:ssZ */
export type TimestampBoundaries = {
  /**
   * Inclusive
   *
   * The ending timestamp to search for content
   */
  end?: InputMaybe<Scalars['String']>;
  /**
   * Inclusive
   *
   * The beginning timestamp to search for content
   */
  start?: InputMaybe<Scalars['String']>;
};

/** Content Item type */
export enum Type {
  Article = 'ARTICLE',
  Shortform = 'SHORTFORM'
}

export type GetActiveFixturesQueryVariables = Exact<{
  input?: InputMaybe<FixtureSearchInput>;
}>;


export type GetActiveFixturesQuery = { __typename?: 'Query', getActiveFixtures?: Array<{ __typename?: 'Fixture', id: string, scheduledStartTime?: string | null, currentGameTime?: string | null, scheduledEndTime?: string | null, gameStatus?: GameStatus | null, tvNetwork?: { __typename?: 'TVNetwork', name: string } | null, sport?: { __typename?: 'GenericSport', name: string } | null, teams: Array<{ __typename?: 'FixtureTeamSummary', currentScore?: number | null, moneyLine?: number | null, pointSpread?: number | null, team: { __typename?: 'Team', abbreviation?: string | null, name: string, primaryColor?: string | null, winCount: number, loseCount: number, drawCount: number, image?: { __typename?: 'ImageReference', url: string } | null } } | null> } | null> | null };

export type GetArticleBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  contentStatus?: InputMaybe<StatusSelector>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetArticleBySlugQuery = { __typename?: 'Query', getSingleArticle?: { __typename?: 'Article', firstPublishedAt?: string | null, lastPublishedAt?: string | null, publishedDate?: string | null, slug: string, id: string, title: string, body: string, description: string, seo: { __typename?: 'SEOInformation', description?: string | null, noIndex?: boolean | null, canonicalUrl?: string | null, title?: string | null, openGraphTag?: { __typename?: 'OpenGraphTag', title: string, type?: string | null, image?: { __typename?: 'ImageReference', url: string } | null } | null }, sport: { __typename?: 'GenericSport', name: string, logo?: { __typename?: 'ImageReference', url: string } | null }, thumbnailImageUrl?: { __typename?: 'ImageReference', url: string } | null, hero?: { __typename?: 'ArticleHero', jwPlayerId?: string | null, jwPlayerPlayerId?: string | null, imageUrl?: { __typename?: 'ImageReference', url: string } | null } | null, author: { __typename?: 'ContentAuthor', id: string, name: string, thumbnailUrl?: string | null, socialMedia?: Array<{ __typename?: 'SocialMediaAccount', accountName: string, type: SocialMediaType, url: string } | null> | null } } | null };

export type GetArticlesNoSportQueryVariables = Exact<{
  filter: ArticleSearchInput;
}>;


export type GetArticlesNoSportQuery = { __typename?: 'Query', getArticles?: { __typename?: 'ArticleList', totalCount: number, articles: Array<{ __typename?: 'ArticleConnection', entity: { __typename?: 'Article', id: string, publishedDate?: string | null, slug: string } } | null> } | null };

export type GetArticlesQueryVariables = Exact<{
  filter: ArticleSearchInput;
}>;


export type GetArticlesQuery = { __typename?: 'Query', getArticles?: { __typename?: 'ArticleList', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, cursor: string }, articles: Array<{ __typename?: 'ArticleConnection', entity: { __typename?: 'Article', firstPublishedAt?: string | null, lastPublishedAt?: string | null, publishedDate?: string | null, slug: string, description: string, id: string, title: string, seo: { __typename?: 'SEOInformation', description?: string | null }, sport: { __typename?: 'GenericSport', name: string, logo?: { __typename?: 'ImageReference', url: string } | null }, thumbnailImageUrl?: { __typename?: 'ImageReference', url: string } | null, hero?: { __typename?: 'ArticleHero', imageUrl?: { __typename?: 'ImageReference', url: string } | null } | null, author: { __typename?: 'ContentAuthor', name: string, id: string } } } | null> } | null };

export type GetAuthorContentQueryVariables = Exact<{
  sportName?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Type>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetAuthorContentQuery = { __typename?: 'Query', getAuthors?: { __typename?: 'ContentAuthorList', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, cursor: string }, authors: Array<{ __typename?: 'ContentAuthorConnection', entity: { __typename?: 'ContentAuthor', id: string, name: string, thumbnailUrl?: string | null, authoredContent?: Array<{ __typename?: 'Article', slug: string, title: string, id: string, publishedDate?: string | null, modifiedDate: string, sport: { __typename?: 'GenericSport', name: string }, thumbnailImageUrl?: { __typename?: 'ImageReference', url: string } | null } | { __typename?: 'ContentSummary', slug: string, title: string, id: string, publishedDate?: string | null, modifiedDate: string } | { __typename?: 'ShortForm', slug: string, title: string, id: string, publishedDate?: string | null, modifiedDate: string } | null> | null, socialMedia?: Array<{ __typename?: 'SocialMediaAccount', url: string, accountName: string } | null> | null } } | null> } | null };

export type GetFeaturedArticlesQueryVariables = Exact<{
  filter?: InputMaybe<FeaturedArticleInput>;
}>;


export type GetFeaturedArticlesQuery = { __typename?: 'Query', getFeaturedArticles?: Array<{ __typename?: 'Article', firstPublishedAt?: string | null, lastPublishedAt?: string | null, publishedDate?: string | null, slug: string, id: string, title: string, description: string, seo: { __typename?: 'SEOInformation', description?: string | null, noIndex?: boolean | null, canonicalUrl?: string | null, title?: string | null, openGraphTag?: { __typename?: 'OpenGraphTag', title: string, type?: string | null, image?: { __typename?: 'ImageReference', url: string } | null } | null }, sport: { __typename?: 'GenericSport', name: string, logo?: { __typename?: 'ImageReference', url: string } | null }, thumbnailImageUrl?: { __typename?: 'ImageReference', url: string } | null, hero?: { __typename?: 'ArticleHero', imageUrl?: { __typename?: 'ImageReference', url: string } | null } | null, author: { __typename?: 'ContentAuthor', name: string, id: string } } | null> | null };

export type GetMenusQueryVariables = Exact<{
  isPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMenusQuery = { __typename?: 'Query', getMenus?: Array<{ __typename?: 'Menu', iconUrl?: string | null, name: string, menuItems: Array<{ __typename?: 'NestedLink', behaviour?: LinkBehaviour | null, text: string, url: string, iconUrl?: string | null, imageUrl?: string | null, children?: Array<{ __typename?: 'NestedLink', behaviour?: LinkBehaviour | null, text: string, url: string, imageUrl?: string | null, iconUrl?: string | null, children?: Array<{ __typename?: 'NestedLink', behaviour?: LinkBehaviour | null, text: string, url: string, imageUrl?: string | null, iconUrl?: string | null, children?: Array<{ __typename?: 'NestedLink', behaviour?: LinkBehaviour | null, text: string, url: string, iconUrl?: string | null, imageUrl?: string | null } | null> | null } | null> | null } | null> | null } | null> } | null> | null };

export type GetShortFormsQueryVariables = Exact<{
  sportName?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetShortFormsQuery = { __typename?: 'Query', getShortForms?: { __typename?: 'ShortFormList', pageInfo: { __typename?: 'PageInfo', cursor: string, hasNextPage: boolean }, shortForms: Array<{ __typename?: 'ShortFormConnection', cursor: string, entity: { __typename?: 'ShortForm', id: string, title: string, body: string, description: string, publishedDate?: string | null, seo: { __typename?: 'SEOInformation', description?: string | null }, tags: Array<{ __typename?: 'ContentTag', name?: string | null, type?: string | null, thumbnailImage?: { __typename?: 'ImageReference', url: string } | null } | null> } } | null> } | null };

export type GetSupportedSportsQueryVariables = Exact<{
  isPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSupportedSportsQuery = { __typename?: 'Query', getSupportedSports?: Array<{ __typename?: 'GenericSport', name: string, hasLiveScoring?: boolean | null, hasPlayerUpdates?: boolean | null, slug: string, seo: { __typename?: 'SEOInformation', description?: string | null, canonicalUrl?: string | null, title?: string | null, noIndex?: boolean | null, image?: { __typename?: 'ImageReference', url: string } | null, openGraphTag?: { __typename?: 'OpenGraphTag', title: string, type?: string | null, image?: { __typename?: 'ImageReference', url: string } | null } | null } } | null> | null };


export const GetActiveFixturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveFixtures"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FixtureSearchInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveFixtures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"currentGameTime"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"gameStatus"}},{"kind":"Field","name":{"kind":"Name","value":"tvNetwork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentScore"}},{"kind":"Field","name":{"kind":"Name","value":"moneyLine"}},{"kind":"Field","name":{"kind":"Name","value":"pointSpread"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"winCount"}},{"kind":"Field","name":{"kind":"Name","value":"loseCount"}},{"kind":"Field","name":{"kind":"Name","value":"drawCount"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveFixturesQuery, GetActiveFixturesQueryVariables>;
export const GetArticleBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArticleBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusSelector"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSingleArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"contentStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"isPreview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"noIndex"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openGraphTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImageUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jwPlayerId"}},{"kind":"Field","name":{"kind":"Name","value":"jwPlayerPlayerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"socialMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>;
export const GetArticlesNoSportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArticlesNoSport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetArticlesNoSportQuery, GetArticlesNoSportQueryVariables>;
export const GetArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImageUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetArticlesQuery, GetArticlesQueryVariables>;
export const GetAuthorContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthorContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sportName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Type"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAuthors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sportName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sportName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"afterCursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedDate"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImageUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"socialMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthorContentQuery, GetAuthorContentQueryVariables>;
export const GetFeaturedArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeaturedArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FeaturedArticleInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFeaturedArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"noIndex"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openGraphTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImageUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetFeaturedArticlesQuery, GetFeaturedArticlesQueryVariables>;
export const GetMenusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMenus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMenus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isPreview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iconUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"menuItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"behaviour"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"iconUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"behaviour"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"iconUrl"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"behaviour"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"iconUrl"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"behaviour"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"iconUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMenusQuery, GetMenusQueryVariables>;
export const GetShortFormsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getShortForms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sportName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getShortForms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sportName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sportName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"afterCursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortForms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetShortFormsQuery, GetShortFormsQueryVariables>;
export const GetSupportedSportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupportedSports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSupportedSports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isPreview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPreview"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasLiveScoring"}},{"kind":"Field","name":{"kind":"Name","value":"hasPlayerUpdates"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noIndex"}},{"kind":"Field","name":{"kind":"Name","value":"openGraphTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSupportedSportsQuery, GetSupportedSportsQueryVariables>;